import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "load-indicator__wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "load-indicator__indicator" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "load-indicator__text" }, "Loading", -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["load-indicator", [{ 'state-visible': $props.loadingResults === true }, { 'load-indicator-transition': $props.useTransition === true }]])
    }, _hoisted_4, 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass([`load-indicator-cover`, { 'load-indicator-cover-transition': $props.useTransition === true }, { 'state-visible': $props.loadingResults === true }])
    }, null, 2 /* CLASS */)
  ]))
}